import React, { useState, useCallback } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import GradientButton from 'components/common/GradientButton'
import Button from '@material-ui/core/Button'
import { observer } from 'mobx-react-lite'
import useStore from 'hooks/useStore'
import api from 'utils/api'
import { useSnackbar } from 'notistack'

function DbPanel() {
	const store = useStore()
	const { enqueueSnackbar } = useSnackbar()

	const [open, setOpen] = useState(false)

	const handleClickOpen = useCallback(() => {
		setOpen(true)
	}, [])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [])

	async function deleteAll() {
		try {
			await api.delete('/api/message.php')
			store.deleteAll()
			setOpen(false)
			enqueueSnackbar('로그를 삭제했습니다.', { variant: 'success' })
		} catch (e) {
			enqueueSnackbar(e.response.data.message || 'DB를 삭제할 수 없습니다.', { variant: 'error' })
		}
	}

	return (
		<>
			<GradientButton color="error" variant="contained" size="large" onClick={handleClickOpen}>
				웹박수 로그를 삭제합니다
			</GradientButton>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">웹박수 로그를 삭제하겠습니까?</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						삭제된 로그는 복구할 수 없습니다.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						취소
					</Button>
					<Button onClick={deleteAll} color="primary" autoFocus>
						확인
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

export default observer(DbPanel)
